import styled from 'styled-components';

interface ITouchScreen {
  isTouchScreen: boolean;
}

export const QuoteDataContainer = styled.div`
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #64b82a;
  color: #64b82a;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-top: 5px;
  cursor: pointer;
  box-sizing: border-box;
  height: 37px;
  min-width: 356px;
  max-width: 369px;

  &:hover {
    background: ${({ isTouchScreen }: ITouchScreen) =>
      isTouchScreen ? `rgba(100, 184, 42, 0.1)` : `none`};
  }

  @media (max-width: 512px) {
    max-width: inherit;
    min-width: inherit;
  }

  .quote-data-popup {
    max-width: 369px;
    box-sizing: border-box;
    right: -13px;
    z-index: 9999;
    @media (max-width: 512px) {
      max-width: inherit;
      width: 100vw;
      transform: translate(0, 0) !important;
      right: -23px;
    }

    > div:last-child svg {
      margin-left: 172px;

      @media (max-width: 512px) {
        margin-left: 0;
      }
    }
  }

  .main-text {
    font-size: 12px;
  }

  .open-popup {
    color: #8c969d;
    cursor: pointer;
    border-bottom: 1px dashed;

    &:hover {
      color: #478cc8;
    }
  }

  .format-currency {
    height: 100%;
    display: flex;
    align-items: center;
    flex: 1;
  }
`;
